import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { CurrentRateInfoDocument } from '../graphql/generated';
import { toPercentageStr } from '../util/numbers';

export const useCurrentRateInfo = () => {
    const { data } = useQuery(CurrentRateInfoDocument);
    return { currentRateInfo: data?.currentRateInfo };
};

export const useMoneyMarketRatePublic = (): string | undefined => {
    const [moneyMarketRate, setMoneyMarketRate] = useState<string>();

    useEffect(() => {
        const fetchRate = async () => {
            try {
                const response = await fetch(
                    'https://api.withplenty.com/public/rates'
                );
                const data = await response.json();
                setMoneyMarketRate(toPercentageStr(data.moneyMarketRate));
            } catch (error) {
                console.error('Error fetching rate:', error);
            }
        };

        fetchRate();
    }, []);

    return moneyMarketRate;
};
